 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		19: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		19: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"851351df509df0a1bdbde0e7b013a82edc68802c","1":"styles","2":"b411d20e8f14e1ec5db920b6c0a1dba6ad5679a6","3":"da091583101b6f57dbfb31f2d9c52232ad0c52af","4":"framework","5":"baa1987cc6337d2ab3c1d0f55e30730a4974edf6","6":"2e2166da9851268be9e62cc877a2603a20cee1db","7":"dad739f4fadc88078ae156f01e421375556fae00","8":"a8f95c35f81d084e9f7b2597aa5aee1f913e0a48","9":"296d40b85b3cc2b72cc62726c387ec0bd8c64dd3","10":"4830b8ba55feac2875c6fe2c98c7a0173aa9b56e","11":"6564192b96c84fc7ab700cc1bca9beb1ed2b0d6b","12":"66e4c39919229f513fddaa72c3841952aa1bfce4","13":"88682331","14":"8940c012ed3d06ad8de032f405fa0134ec155993","15":"a0984feefbbeaed32a8e51ab799f378041b4fd37","16":"a5985b4268f34c5dd750100ab166c0db3e8d03ac","17":"e496bb7597216b30a065f0f34257fcd48d228c7d","18":"f6be765342124f39c26c42bf5a71ffb99cd28d66","22":"component---cache-caches-gatsby-plugin-offline-app-shell-js","23":"component---src-pages-404-js","24":"component---src-pages-compare-unit-id-js","25":"component---src-pages-compare-unit-js","26":"component---src-pages-development-commercial-id-js","27":"component---src-pages-development-commercial-js","28":"component---src-pages-development-details-id-js","29":"component---src-pages-development-details-js","30":"component---src-pages-development-future-developments-id-js","31":"component---src-pages-development-future-developments-js","32":"component---src-pages-development-hospitalities-id-js","33":"component---src-pages-development-hospitalities-js","34":"component---src-pages-development-industrial-id-js","35":"component---src-pages-development-industrial-js","36":"component---src-pages-development-office-id-js","37":"component---src-pages-development-office-js","38":"component---src-pages-development-residential-id-js","39":"component---src-pages-development-residential-js","40":"component---src-pages-experiment-id-js","41":"component---src-pages-experiment-js","42":"component---src-pages-forgot-password-id-js","43":"component---src-pages-forgot-password-js","44":"component---src-pages-login-id-js","45":"component---src-pages-login-js","46":"component---src-pages-profile-id-js","47":"component---src-pages-profile-js","48":"component---src-pages-register-id-js","49":"component---src-pages-register-js","50":"component---src-pages-search-result-id-js","51":"component---src-pages-search-result-js","52":"component---src-pages-socialmedia-id-js","53":"component---src-pages-socialmedia-js","54":"component---src-pages-subscribe-id-js","55":"component---src-pages-subscribe-js","56":"component---src-pages-thankyou-js","57":"component---src-templates-access-details-js","58":"component---src-templates-development-details-js","59":"component---src-templates-facilities-details-js","60":"component---src-templates-news-details-amp-js","61":"component---src-templates-news-details-js","62":"component---src-templates-news-landing-js","63":"component---src-templates-our-partners-details-js","64":"component---src-templates-pages-js","65":"component---src-templates-sub-page-js","66":"component---src-templates-tnc-js"}[chunkId]||chunkId) + "-" + {"0":"0d28c4ee564585442f88","1":"e9d24b1846c7d6eb9685","2":"c10cbe95be2148514832","3":"75e31aa6b9d8e3f27bbf","4":"d5d8a48f993ae9e13f36","5":"fa23d43567d48ac9a4df","6":"8f5fb35091bc8b6b413c","7":"a02dc326b992dcb0eef1","8":"7c64925c96caa43d1b9d","9":"a48087895342c85cd862","10":"3b7fb5e7f4f6112dc8e2","11":"88ae588d033ff09ac453","12":"b12295c2f28076170055","13":"b5539296f859731a4cd9","14":"2676d57d23501cd58816","15":"cb224544f0e17b53e5f4","16":"6ea55775864bf9c3b40a","17":"1f1b6ab29d7d1899fc25","18":"01bf1372b4a56d9c0b80","20":"5c839dd5538cf90b907d","22":"0e5fc68045a6ef2601fe","23":"71f302d460e8a65582a5","24":"931234ee1aa6720f2881","25":"ef1f8d61116d95204850","26":"6a8cc5134cfa6044a08b","27":"c8ee04ce8b3e9169f06b","28":"52132548836da5a6d0da","29":"246e88413252bce49d41","30":"61985b67eddd70b2f1bc","31":"9894663b1b0b0c199cb6","32":"4461c04c65183f03fd2a","33":"1a37c69df5f830a35ca0","34":"c06067e13a4d4a9bd579","35":"92a943e10f8dfa563de4","36":"dbd2e5e401992be291ca","37":"d7c4c12aa28c012a5cbf","38":"de5b9f7f17324e5b5844","39":"c06b5e30b7b3ad33f64c","40":"ab920bd3ed5545ac1611","41":"a784d205fcfc4ddec015","42":"1a7a08bab8fae85deb5b","43":"5beb931e322807208737","44":"4332ce2be29422a73ba7","45":"adf463377bdc433f6105","46":"ebab8337fec7b2f75fff","47":"a093e36ecb2f917574c6","48":"b1bab4988e6a3822c6eb","49":"2351d572ac00c1844f29","50":"c1a4e6d4befb972dcada","51":"9d80bee66f354b0af4ff","52":"b80ff1501eddbf927979","53":"8ed144aca3f916a3b50a","54":"32860f86038c55e64174","55":"6977d14d0c961d2e5ed6","56":"8ad64422f1b4117bcd9e","57":"e2104620f98458aedad7","58":"2c4fd9a5415a7427067c","59":"77de7ed2446d11b6f7c1","60":"c9d7166ddbcfd235e6c8","61":"873e4d75cf3af5900286","62":"3fc8b3c333705586805e","63":"adb3c885a77dae71f5a7","64":"c69ff6e2590beaf3adaa","65":"bebb3ee8b95495f87cdd","66":"6453afc0d92424815faa","68":"ae7073f83c77f10d3ec7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"851351df509df0a1bdbde0e7b013a82edc68802c","1":"styles","2":"b411d20e8f14e1ec5db920b6c0a1dba6ad5679a6","3":"da091583101b6f57dbfb31f2d9c52232ad0c52af","4":"framework","5":"baa1987cc6337d2ab3c1d0f55e30730a4974edf6","6":"2e2166da9851268be9e62cc877a2603a20cee1db","7":"dad739f4fadc88078ae156f01e421375556fae00","8":"a8f95c35f81d084e9f7b2597aa5aee1f913e0a48","9":"296d40b85b3cc2b72cc62726c387ec0bd8c64dd3","10":"4830b8ba55feac2875c6fe2c98c7a0173aa9b56e","11":"6564192b96c84fc7ab700cc1bca9beb1ed2b0d6b","12":"66e4c39919229f513fddaa72c3841952aa1bfce4","13":"88682331","14":"8940c012ed3d06ad8de032f405fa0134ec155993","15":"a0984feefbbeaed32a8e51ab799f378041b4fd37","16":"a5985b4268f34c5dd750100ab166c0db3e8d03ac","17":"e496bb7597216b30a065f0f34257fcd48d228c7d","18":"f6be765342124f39c26c42bf5a71ffb99cd28d66","22":"component---cache-caches-gatsby-plugin-offline-app-shell-js","23":"component---src-pages-404-js","24":"component---src-pages-compare-unit-id-js","25":"component---src-pages-compare-unit-js","26":"component---src-pages-development-commercial-id-js","27":"component---src-pages-development-commercial-js","28":"component---src-pages-development-details-id-js","29":"component---src-pages-development-details-js","30":"component---src-pages-development-future-developments-id-js","31":"component---src-pages-development-future-developments-js","32":"component---src-pages-development-hospitalities-id-js","33":"component---src-pages-development-hospitalities-js","34":"component---src-pages-development-industrial-id-js","35":"component---src-pages-development-industrial-js","36":"component---src-pages-development-office-id-js","37":"component---src-pages-development-office-js","38":"component---src-pages-development-residential-id-js","39":"component---src-pages-development-residential-js","40":"component---src-pages-experiment-id-js","41":"component---src-pages-experiment-js","42":"component---src-pages-forgot-password-id-js","43":"component---src-pages-forgot-password-js","44":"component---src-pages-login-id-js","45":"component---src-pages-login-js","46":"component---src-pages-profile-id-js","47":"component---src-pages-profile-js","48":"component---src-pages-register-id-js","49":"component---src-pages-register-js","50":"component---src-pages-search-result-id-js","51":"component---src-pages-search-result-js","52":"component---src-pages-socialmedia-id-js","53":"component---src-pages-socialmedia-js","54":"component---src-pages-subscribe-id-js","55":"component---src-pages-subscribe-js","56":"component---src-pages-thankyou-js","57":"component---src-templates-access-details-js","58":"component---src-templates-development-details-js","59":"component---src-templates-facilities-details-js","60":"component---src-templates-news-details-amp-js","61":"component---src-templates-news-details-js","62":"component---src-templates-news-landing-js","63":"component---src-templates-our-partners-details-js","64":"component---src-templates-pages-js","65":"component---src-templates-sub-page-js","66":"component---src-templates-tnc-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"2a386d2a37c8362768a4","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
